/**
 *  Returns an array with exceptions for the sentence beginning researcher.
 *  @returns {Array} The array filled with exceptions.
 *  */
export default [
	// Indefinite articles:
	"ei", "et",
	// Numbers 1-10:
	"en", "ett", "to", "tre", "fire", "fem", "seks", "sju", "syv", "åtte", "ni", "ti",
	// Demonstrative pronouns:
	"denne", "dette", "disse", "den", "det", "de",
];
